module.exports = __webpack_public_path__ + "img/job-content.be7b1319.svg";